//import React from 'react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Alert from '../../container/Alert';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.forgotpassword.label.name',
    description: 'Page Header Title',
    defaultMessage: 'Forgot Password'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ' '
  },

  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class PasswordForgot extends Component {

  render() {
      return (

 // const PasswordForgot = ({ forgetpassword, locale, intl, status }) => (  // original
  <div className="preview page">
    <Helmet>
      <title>{this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
    </Helmet>
    <Header
      title={this.props.intl.formatMessage(messages.headerTitle)}
      subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
      icon="preview"
      locale={this.props.locale}
      status = {this.props.status}
    />

    <div className="main">
      <div
        className="panel"
        style={{
          width: '45%',
          padding: '40px',
          boxSizing: 'content-box',
          marginTop: '15px',
          display: 'block',
          alignContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <LocalForm
          onSubmit={({ email }) => this.props.forgetpassword(email)}
          className="form"
        >
          <fieldset>
            <label style={{ textTransform: 'capitalize' }}>
              <FormattedMessage
                id="assessment.request.translation.Email.name"
                defaultMessage="Email"
              />
            </label>

            <Control.text model=".email" defaultValue={this.props.match.params.id} type="email" required autoFocus />
          </fieldset>

          <div className="button-container" style={{ textAlign: 'center' }}>
            <button className="button" type="submit">
              <FormattedMessage
                id="user.resetpassword.label.name"
                defaultMessage="Reset Password"
              />
            </button>
          </div>
        </LocalForm>
      </div>
    </div>
    <Footer />
  </div>
//);

    )
  }
}
PasswordForgot.propTypes = {
  forgetpassword: PropTypes.func.isRequired,
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object
};

export default injectIntl(PasswordForgot);



// WEBPACK FOOTER //
// ./src/components/views/PasswordForgot/index.js